import { Application } from "./application";
import { Company } from "./company";
import { Material } from "./material";
import { Site } from "./site";

export class Toll {
    id?: string;
    siteId?: string | null;
    site?: Site;
    companyId?: string | null;
    company?: Company;
    date?: Date | string;
    quantity?: number
    plate?: string;
    materialId?: string | null;
    material?: Material;
    isTruck?: boolean;
    isExceptionalConvoy?: boolean;
    applicationId?: string | null;
    application?: Application;
    billed?: boolean;
    processed?: boolean;
    isError?: boolean;
    creationDate?: Date | string;

    constructor(toll?: Toll) {
        this.id = toll?.id
        this.siteId = toll?.siteId || (toll?.site ? toll?.site.id : null);
        this.site = toll?.site;
        this.companyId = toll?.companyId || (toll?.company ? toll?.company.id : null);
        this.company = toll?.company;
        this.date = toll?.date;
        this.quantity = toll?.quantity;
        this.plate = toll?.plate;
        this.materialId = toll?.materialId || (toll?.material ? toll?.material.id : null);
        this.material = toll?.material;
        this.isTruck = toll?.isTruck;
        this.isExceptionalConvoy = toll?.isExceptionalConvoy;
        this.applicationId = toll?.applicationId || (toll?.application ? toll?.application.id : null);
        this.application = toll?.application;
        this.billed = toll?.billed;
        this.processed = toll?.processed;
        this.isError = toll?.isError;
        this.creationDate = toll?.creationDate;
    }
}
